import type {
    EditSignalModalProps,
} from "app/pages/sales-intelligence/sub-modules/signals/components/modals/EditSignalModal/EditSignalModal";
import EditSignalModal from "app/pages/sales-intelligence/sub-modules/signals/components/modals/EditSignalModal/EditSignalModal";
import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type UISignal from "app/pages/sales-intelligence/sub-modules/signals/models/view/UISignal";
import trackingService from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/trackingService";

type Props = EditSignalModalProps & {
    selectedEditSignal: UISignal<SignalFilters>;
};

const EditSignalModalTracked = (props: Props) => {
    const { selectedEditSignal, ...modalProps } = props;

    function handleReturnTrackedClick() {
        trackingService.management.trackEditReturnSignalEvent(selectedEditSignal);
        props.onReturn();
    }

    function handleCloseTrackedClick() {
        trackingService.management.trackEditCancelSignalEvent(selectedEditSignal);
        props.onClose();
    }

    return (
        <EditSignalModal
            {...modalProps}
            onReturn={handleReturnTrackedClick}
            onClose={handleCloseTrackedClick}
        >
            {props.children}
        </EditSignalModal>
    );
}

export default EditSignalModalTracked;
